import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'
import notify from './notify'
import maintenance from './maintenance'
import tenant from './tenant'
import events from './events'
import recordProfile from './recordProfile'
import departments from './departments'
import adminInformation from './adminInformation'
import notifications from './notifications'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: false,
    isConditionButtonActive: false,
    selectedDate: new Date(),
    canDisplayPwaPopup: true,
    hasNotifications: false,
    // アプリが更新された日付
    loadedAt: new Date(),
  },
  mutations: {
    startLoading(state) {
      state.isLoading = true
    },
    finishLoading(state) {
      state.isLoading = false
    },
    toggleIsConditionButtonActive(state) {
      state.isConditionButtonActive = !state.isConditionButtonActive
    },
    setCanDisplayPwaPopup(state, canDisplayPwaPopup) {
      state.canDisplayPwaPopup = canDisplayPwaPopup
    },
    setHasNotifications(state, hasNotifications) {
      state.hasNotifications = hasNotifications
    },
    setLoadedAt(state, loadedAt) {
      state.loadedAt = loadedAt
    },
    setSelectedDate(state, date) {
      state.selectedDate = date
    },
  },
  actions: {},
  modules: {
    auth,
    notify,
    maintenance,
    tenant,
    events,
    recordProfile,
    departments,
    adminInformation,
    notifications,
  },
  plugins: [createPersistedState({
    paths: [
      'auth.accessToken',
      'auth.refreshToken',
      'auth.user',
      'auth.apiDomain',
      'maintenance.maintenanceInfo',
      'tenant',
      'events.selectedCategories',
      'events.categories',
      'events.pinnedCategories',
      'recordProfile.selectedMemberIds',
      'recordProfile.academicRecordsGradeCode',
      'departments.pinnedDepartments',
      'adminInformation.notDisplayAdminInfos',
      'notifications.selectedTag1',
      'notifications.selectedTag2',
      'notifications.isTagFilterActive',
      'notifications.isCommentFilterActive',
    ]
  })],
})
